import { Panel } from '@/components/ui/Panel';

/** Shown when the Supabase environment variables are missing. Better a
 *  clear instruction than a white screen. */
export function ConfigError() {
  return (
    <div className="login">
      <div className="login__card" style={{ maxWidth: 520 }}>
        <Panel title="Configuration required">
          <p>The app cannot reach Supabase because its connection settings are missing.</p>
          <p className="muted small">Set these and redeploy:</p>
          <pre
            className="small"
            style={{
              background: 'var(--bg-input)',
              border: '1px solid var(--border-weak)',
              borderRadius: 'var(--radius-md)',
              padding: 'var(--sp-3)',
              overflowX: 'auto',
            }}
          >
{`VITE_SUPABASE_URL=https://<project-ref>.supabase.co
VITE_SUPABASE_ANON_KEY=<anon key>`}
          </pre>
          <p className="muted small">
            Locally: copy <code>.env.example</code> to <code>.env.local</code>.
            On Netlify: Site configuration → Environment variables, then redeploy.
          </p>
        </Panel>
      </div>
    </div>
  );
}
